



































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { EnquiryProduct } from '@/models/enquiry-product';
import { EnquiryApi } from '@/api/enquiry-api';
import { Enquiry } from '@/models/enquiry';
import { QuoteProduct } from '@/models/quote-product';
import { Quote } from '@/models/quote';
import { QuoteHistory } from '@/models/quote-history';
import { namespace } from 'vuex-class';
import quoteStatusLabel from '@/components/quote-status-label.vue';
import quoteHistoryDescription from '@/components/quote-history-description.vue';
import { Permissions } from '@/models/permission-constants';

const UserModule = namespace('user');

@Component({
    components: {
        quoteStatusLabel,
        quoteHistoryDescription,
    },
})
export default class EnquiryDetails extends Vue {
    @Prop({ required: true }) public quote: Quote;
    @Prop({ required: true }) public history: Array<QuoteHistory>;
    @UserModule.Getter public canViewOrders: boolean;
    @UserModule.Getter public canCreateOrders: boolean;
    @UserModule.Getter public canViewQuotes: boolean;
    public products: Array<QuoteProduct> = this.quote.products;

    public acceptApprovalClicked(): void {
        this.$emit('approval-accepted', this.quote.latestApprovalId);
    }
    public rejectApprovalClicked(): void {
        this.$emit('approval-rejected', this.quote.latestApprovalId);
    }
}
